import * as React from 'react';

import {
  IStepInfo as Step,
} from '@frontend/applications/Shared/Wizard/container';
import { useClientFeatures } from '@frontend/context/ClientFeatureContext';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@frontend/shadcn/components/ui/sheet';
import { RefreshWizardContainer } from '@frontend/applications/Shared/Wizard/container/Wizard/RefreshWizard';
import { AddMembers as AddMembersIcon } from '../Icons';
import { useAddMembers } from '../../hooks';
import { TAddMembersProps } from '../../types';
import { OfferDetailCard } from '../../../AffiliatesApp/components/OfferDetailCard';
import { RefreshConfirmClose } from './RefreshConfirmClose';

const { useCallback, useEffect } = React;

export const RefreshAddMembers: React.FC<Readonly<TAddMembersProps>> = (props) => {
  const {
    fetchPrograms,
    onClose,
    visible,
    isWorkflow,
    offerSource,
  } = props;
  const { isProjects, migrateToGraphQL } = useClientFeatures();
  const { actions, state, steps } = useAddMembers({ ...props, isProjects, migrateToGraphQL });

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (state.programs !== null || state.error !== null) {
      return;
    }
    fetchPrograms()
      .then(actions.populatePrograms)
      .catch(actions.setError);
  }, [
    actions.populatePrograms,
    actions.setError,
    fetchPrograms,
    state.error,
    state.programs,
    visible,
  ]);

  const handleCloseClick = useCallback(() => {
    if (state.saving) {
      return;
    }
    if (!state.error && state.currentStep > 1 && state.currentStep < 5) {
      actions.showCloseConfirmation();
      return;
    }
    onClose();
  }, [
    actions,
    onClose,
    state.currentStep,
    state.error,
    state.saving,
  ]);

  let contents;
  if (state.showCloseConfirmation) {
    contents = (
      <RefreshConfirmClose
        onConfirm={onClose}
        onDismissConfirmation={actions.dismissCloseConfirmation}
      />
    );
  } else {
    const hideNavigation = (
      !!state.error
      || (state.showNoMembersWarning)
    );
    contents = (
      <RefreshWizardContainer
        hideNavigation={hideNavigation}
        icon={<AddMembersIcon offerSource={offerSource} />}
        onCancel={onClose}
        onStepChange={actions.setCurrentStep}
        step={state.currentStep}
        stepsInfo={steps as Step[]}
        noHeader={isWorkflow}
        noBodyPadding={isWorkflow}
        hideHeader
      />
    );
  }
  if (isWorkflow) {
    return <div>{contents}</div>;
  }

  return (
    <Sheet open={visible} onOpenChange={handleCloseClick} modal>
      <SheetContent side="right" className="flex flex-col h-full bg-grey-0 p-0 gap-0 w-[576px] !max-w-[576px] overflow-hidden">
        <SheetHeader className="p-4 flex items-center gap-2 flex-row shrink-0">
          <SheetTitle className="!m-0 text-base font-medium"> Add Members</SheetTitle>
        </SheetHeader>
        <div className="flex items-center gap-2 px-4 py-2 bg-grey-1 border-t border-b border-grey-2">
          <OfferDetailCard
            showCta={false}
            isWorkFlow={isWorkflow}
            infoButtonClassName
          />
        </div>
        <div className="flex-1 overflow-y-auto">
          {contents}
        </div>
      </SheetContent>
    </Sheet>
  );
};
